/**
 * File feature-banner.js.
 * Displays a feature banner on the homepage
 */
function featureBanner($) {
  const featureBanner = document.querySelector('.feature-banner');
  const featureBannerBtn = document.querySelector('.feature-banner__btn');
  const featureBannerPlacement = featureBanner.getAttribute('data-placement');
  const featureBannerClose = document.querySelector('.feature-banner__close');
  const header = document.querySelector('.header');
  const headerClass = 'header--feature-' + featureBannerPlacement;
  const bannerClass = 'feature-banner--mb';

  const heroModules = [
    'video-background-slider',
    'hero-video',
    'hero',
    'logo-hero',
  ];

  const hasHeroModule = heroModules.some(module => document.querySelector(`.${module}`));

  const toggleFeatureBanner = () => {
    if (header) header.classList.toggle(headerClass);
    if (hasHeroModule) {
      heroModules.forEach(module => {
        const heroModule = document.querySelector(`.${module}`);
        if (heroModule) {
          heroModule.classList.toggle(`${module}--feature-${featureBannerPlacement}`);
        }
      });
    }
  };

  const closeFeatureBanner = () => {
    featureBanner.style.display = 'none';
    toggleFeatureBanner();
  };

  const handleLearnMoreClick = (e) => {
    const learnMoreBtn = e.target;
    const learnMoreLocation = window.location.href;
    const learnMoreText = learnMoreBtn.textContent;
    const learnMoreHref = learnMoreBtn.getAttribute('href');

    const properties = {
      interaction_type: "INTERACTION_TYPE_FEATURE_BANNER_CTA_CLICKED", 
      interaction_details: {
        location: learnMoreLocation,
        action_detail: learnMoreText,
        additional_data: [
          {
            key: "cta_href",
            value: learnMoreHref
          }
        ],
      },
    };

    if (typeof segmentGenericEvent === 'function') {
      segmentGenericEvent('track', properties);
    }

    // Analytics SDK double fire
    fireAnalyticsEvent(Track.WebItemClicked, {
      unique_id: 'feature_banner_cta_clicked',
      label: learnMoreText,
      element_type: 'ELEMENT_TYPE_BUTTON',
      item_value: learnMoreHref,
    });
  } 
  if (!hasHeroModule) featureBanner.classList.add(bannerClass);
  featureBannerClose.addEventListener('click', closeFeatureBanner);

  if (featureBannerBtn) {
    featureBannerBtn.addEventListener('click', handleLearnMoreClick);
  }
}

// Init
if (typeof jQuery !== 'undefined') jQuery(function ($) {
  featureBanner($);
});
